<template>
	<div class="connect_bg">
		<div class="connect_wrap help-wrap">
			<div class="connect_close_btn" @click="close"></div>
			<div class="title">如何开启Windows主机WOL功能</div>
			<div class="content-wrap">
				<div class="sub-sub-title">①判断设备是否支持远程开机</div>
				<div class="sub-content">
					<p>1.重启电脑设备进入BIOS的电源管理菜单</p>
					<p>
						2.查看菜单是否有Remote Wake Up或Wake on
						LAN等类似选项，否则不支持远程开机。
					</p>
				</div>

				<div class="sub-sub-title">②进入BIOS</div>
				<div class="sub-content">
					<p>
						1.开机时反复按“DELTET”或“F2/F8/F12”等按键进入BIOS设置界面
					</p>
					<p>2.具体按键可参考主板说明书或参考网络教程。</p>
				</div>

				<div class="sub-sub-title">③开启唤醒功能</div>
				<div class="sub-content">
					<p>
						通常到“Power
						Managment（电源管理）”下寻找如下列选项或类似的配置项，并可以启用它。
					</p>
				</div>

				<div class="code-wrap">
					<p>"Boot on LAN";</p>
					<p>"Wake on LAN";</p>
					<p>"PME Event WakeUp",;</p>
					<p>"Resume by MAC LAN";</p>
					<p>"Wake-Up by PCI card";</p>
					<p>"Wake Up On PCI PME";</p>
					<p>"Power On by PCI Card";</p>
					<p>"WakeUp by PME of PCI";</p>
					<p>"Power On By PCI Devices";</p>
					<p>"WakeUp by Onborad LAN";</p>
					<p>"Resume By PCI or PCI-E Ddevice"</p>
				</div>

				<div class="sub-content">
					<p class="sub-content-title">
						可视化图形的UEFI BIOS，可参考下列设置方式：
					</p>
					<p>
						高级 > 高级电源管理（APM）> 开启 Resume By PCI or PCI-E
						Ddevice（由 pci/pcie 设备唤醒）选项。
					</p>
				</div>

				<div class="sub-sub-title">④系统设置</div>
				<div class="sub-content">
					<p>右键点击开始菜单-设备管理器，对网卡进行设置。</p>
				</div>
				<div class="sub-img">
					<img :src="require('../../assets/wakeup/help-01.jpg')" />
				</div>
				<div class="sub-content">
					<p>网卡电源设置</p>
				</div>
				<div class="sub-img">
					<img :src="require('../../assets/wakeup/help-02.jpg')" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {};
	},
	props: [],
	methods: {
		close: function () {
			let _that = this;
			_that.$emit("close");
		},
	},
	watch: {},
	mounted() {},
};
</script>

<style lang="less" scoped>
.connect_bg {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.1);
	z-index: 9;
	.connect_wrap {
		width: 540px;
		height: 360px;
		position: absolute;
		left: 50%;
		top: 50%;
		margin-top: -180px;
		margin-left: -270px;
		background-color: #f5f5f5;
		background-image: linear-gradient(180deg, #f4f7ff 0%, #ffffff 19.79%);
		border-radius: 5px;
		box-shadow: 0px 0px 14px 2px #999999;
		overflow-y: scroll;
		padding-bottom: 40px;

		.connect_close_btn {
			width: 20px;
			height: 20px;
			position: absolute;
			right: 20px;
			top: 14px;
			cursor: pointer;
			background-image: url(../../assets/common/close2.svg);
			background-size: 100% 100%;
		}

		.code-wrap {
			background: #f0f0f0;
			border: 1px solid #d9d9d9;
			border-radius: 5px;
			padding: 20px;
			margin: 10px auto;
			p {
				font-weight: 600;
				font-size: 12px;
				line-height: 17px;
				color: #000000;
			}
		}
	}
}

.sure-btn {
	margin: 0 auto;
	margin-top: 20px;
	width: 125px;
	height: 42px;
	background-color: #243a5e;
	background-image: linear-gradient(
		157.05deg,
		#243a5e 19.08%,
		#1c2f4d 90.93%
	);
	border-radius: 126px;
	text-align: center;
	font-weight: 400;
	font-size: 14px;
	line-height: 42px;
	color: #ffffff;
}

.sure-btn:hover {
	cursor: pointer;
	opacity: 0.9;
}

.connect_wrap.help-wrap {
	z-index: 10;
	.title {
		font-weight: 600;
		font-size: 20px;
		line-height: 28px;
		text-align: center;
		color: #143977;
		margin-top: 20px;
	}
	.content-wrap {
		width: 450px;
		margin: 0 auto;
		margin-top: 35px;
		.sub-title {
			font-style: normal;
			font-weight: 600;
			font-size: 16px;
			line-height: 22px;

			color: #000000;
			margin-top: 20px;
		}

		.sub-title2 {
			font-style: normal;
			font-weight: 600;
			font-size: 14px;
			line-height: 22px;

			color: #000000;
			margin-top: 20px;
		}
		.sub-sub-title {
			font-style: normal;
			font-weight: 600;
			font-size: 16px;
			line-height: 20px;

			color: #4277ff;
			margin-top: 20px;
			margin-bottom: 2px;
		}
		.sub-content {
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			line-height: 20px;

			color: #000000;
			span {
				color: #acacac;
			}

			.sub-content-title {
				font-weight: bolder;
				margin-bottom: 4px;
				font-size: 14px;
			}
		}

		.sub-img {
			margin: 10px auto;
			img {
				width: 100%;
			}
		}
	}
}
</style>